enum ActionTypes {
    GET_COMPONENT_ANNOTATIONS = "annotations/getComponentAnnotations",
    GET_COMPONENT_ANNOTATIONS_SUCCESS = "annotations/getComponentAnnotationsSuccess",
    GET_COMPONENT_ANNOTATIONS_FINISH = "annotations/getComponentAnnotationsFinish"
}

export default ActionTypes;
